const keyMirror = require("keymirror");

export const DashboardStepConstants = keyMirror({
  SET_DASHBOARD_STEP: undefined
});
